import { Link } from 'react-router-dom';
import { LinkOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'routes/routes';
import styles from './ProcessMap.module.css';

type OutputCellModalTitleProps = {
  title: string;
};

export const OutputCellModalTitle = ({ title }: OutputCellModalTitleProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.outputCellLinkContainer}>
      <span className={styles.outputCellTitle}>{title}</span>
      <Link to={ROUTES.REPORTS} className={styles.outputCellLink}>
        <span className={styles.outputCellLinkText}>
          {t('create-canvas-process-map.go-to-reports')}
        </span>
        <LinkOutlined />
      </Link>
    </div>
  );
};
